export default {
	all: 'All',
	today: 'Today',
	'orders-settings': 'orders settings',
	'order-status': 'order status',
	'change-order-state': 'Change order state',
	'change-state-to-$': 'change state to {state}?',
	Total: 'Total'
}